module.exports = "/matchcenter-staging/assets/images/logo_sport24.afa5bd0daf6d3b6e5ebe0981eee248e5.svg";